import { Store } from '../../types'

export const loanRepaymentMethodsSelector = (store: Store) => store.entities.loanRepaymentMethods || []
